/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useState } from 'react';

import { BrandingUiInfoKeys } from '../../../../../core/entities';
import { ServicesClientImpl } from '../../../../../core/interactors';
import { ProgramScreenConstants } from '../../../../../store/programscreen/ProgramScreenConstants';
import { THorizontalActionStripLayout } from '../../THorizontalActionStripItem';

import './ImageItem.scss';

interface PosterImageItemProps {
    image: string;
    type: 'PosterImage' | 'LandscapeImage';
    value?: string;
    layout: THorizontalActionStripLayout;
    title?: string;
    isHighlighted?: boolean;
}

const ImageItem: FunctionComponent<PosterImageItemProps> = ({
    value,
    image,
    type,
    layout,
    title,
    isHighlighted,
}) => {
    const services = new ServicesClientImpl();
    const DEFAULT_IMAGE = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.DEFAULT_BACKGROUND,
    );
    const imageClass = type === 'PosterImage' ? 'poster' : 'landscape';

    let viewAllClass = '';
    if (value === ProgramScreenConstants.VIEW_ALL) {
        if (isHighlighted) {
            viewAllClass = 'view-all-highlighted';
        } else {
            viewAllClass = 'view-all-unhighlighted';
        }
    }

    const [hasError, setHasError] = useState(false);

    return (
        <React.Fragment>
            <img
                src={image || DEFAULT_IMAGE?.imageUrl}
                loading="lazy"
                className={`image-item ${imageClass} ${layout} ${viewAllClass}`.trim()}
                onLoad={(e) => {
                    if (new URL(e.currentTarget.src).pathname !== DEFAULT_IMAGE?.imageUrl)
                        setHasError(false);
                }}
                onError={(e) => {
                    e.currentTarget.src = DEFAULT_IMAGE?.imageUrl || '';
                    setHasError(true);
                }}
            />
            {hasError && (
                <span
                    className={`fallback-${layout === ProgramScreenConstants.CAST ? 'cast-icon' : 'image-text'}`}
                >
                    {layout !== ProgramScreenConstants.CAST && title}
                </span>
            )}
            {layout === ProgramScreenConstants.CAST && <span className="cast-title">{title}</span>}
            {value === ProgramScreenConstants.VIEW_ALL && <span className="view-all-line"></span>}
        </React.Fragment>
    );
};

export default ImageItem;
